import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useUserInfo from '@/components/Authenticate/useUserInfo';
// import resourceIcon from '../../assets/resourceIcon.svg';
import downIcon from '../../assets/downIcon.svg';
import upIcon from '../../assets/upIcon.svg';
import recordsIcon from '../../assets/recordsIcon.svg';
import activityLogIcon from '../../assets/activity-log.svg';
// import doctorManagementIcon from '../../assets/doctor-mamagement.svg';
import userManagementIcon from '../../assets/user-management.svg';
import { newPermissionsFeatureCodes } from '@/constants';

const SideDrawer = () => {
  const { userPermissions } = useUserInfo();
  const [submenuVisibility, setSubmenuVisibility] = useState<{
    [key: number]: boolean;
  }>({});
  const [selectedItem, setSelectedItem] = useState<{
    menuId: number | null;
    submenuIndex: number | null;
  }>({ menuId: null, submenuIndex: null });
  const navigate = useNavigate();
  const drawerList = [
    // {
    //   label: 'Resources',
    //   image: resourceIcon,
    //   path: '',
    //   child: [
    //     {
    //       label: 'Dashboard',
    //       path: '',
    //       permissionKeys: [], // No restrictions needed
    //     },
    //   ],
    //   id: 1,
    //   permissionKeys: [permissionsFeatureCodes.sops_view, permissionsFeatureCodes.important_links_view],
    // },
    {
      label: 'User Management',
      image: userManagementIcon,
      path: '',
      child: [
        {
          label: 'Users',
          path: '/user-management',
          permissionKeys: [], // No restrictions needed
        },
      ],
      id: 2,
      permissionKeys: [
        newPermissionsFeatureCodes.user_sa_pa_create,
        newPermissionsFeatureCodes.user_fa_create,
        newPermissionsFeatureCodes.user_records_management_create,
      ], // Parent-specific permissions
    },
    // Todo for future management of doctor management
    // {
    //   label: 'Doctor Management',
    //   image: doctorManagementIcon,
    //   path: '',
    //   child: [
    //     {
    //       label: 'Doctors',
    //       path: '/doctor-management',
    //       permissionKeys: [],
    //     },
    //   ],
    //   id: 3,
    //   permissionKeys: [permissionsFeatureCodes.doctor_profile_create],
    // },
    {
      label: 'Records Management',
      image: recordsIcon,
      id: 4,
      path: '',
      child: [
        // {
        //   label: 'Dashboard',
        //   path: '/validate-report',
        //   permissionKeys: [permissionsFeatureCodes.documents_view],
        // },
        {
          label: 'Document Reviewing',
          path: '/document-review',
          permissionKeys: [newPermissionsFeatureCodes.reviewer_documents_view],
        },
        {
          label: 'Document Validating',
          path: '/validate-report',
          permissionKeys: [newPermissionsFeatureCodes.validator_documents_view],
        },
        {
          label: 'Escalation Management',
          path: '/supervisor',
          permissionKeys: [newPermissionsFeatureCodes.escalated_documents_view],
        },
        // {
        //   label: 'Quality Management',
        //   path: '/qa-audit-flow',
        //   permissionKeys: [permissionsFeatureCodes.quality_check_summary],
        // },
      ],
      permissionKeys: [newPermissionsFeatureCodes.reviewer_documents_view,newPermissionsFeatureCodes.validator_documents_view ,newPermissionsFeatureCodes.escalated_documents_view]
    },
    {
      label: 'Activity Log',
      image: activityLogIcon,
      path: 'audit-log',
      child: [],
      id: 5,
      permissionKeys: [newPermissionsFeatureCodes.logs_view]
    },
  ];

  const toggleSubmenu = (id: number) => {
    setSubmenuVisibility((prevVisibility) => ({
      ...prevVisibility,
      [id]: !prevVisibility[id],
    }));
  };

  const handleMenuClick = (menuId: number, path: string) => {
    setSelectedItem({ menuId, submenuIndex: null });
    navigate(path);
  };

  const handleSubmenuClick = (
    menuId: number,
    submenuIndex: number,
    path: string
  ) => {
    setSelectedItem({ menuId, submenuIndex });
    navigate(path);
  };

  const hasPermission = (keys: string[]) =>
    keys.length === 0 || keys.some((key) => userPermissions?.[key] === 'CHECK_RESULT_ALLOWED');

  const filteredDrawerList = drawerList
    .filter((item) => hasPermission(item.permissionKeys))
    .map((item) => ({
      ...item,
      child: item.child.filter((child) => hasPermission(child.permissionKeys)),
    }));

  return (
    <div
      className="bg-sideDrawer-background h-screen w-64 fixed overflow-y-auto z-50"
      style={{ marginTop: '60px' }}
    >
      <div className="gap-2 py-4 px-1">
        {filteredDrawerList.map((data) => (
          <div key={data.id}>
            <div
              className={`flex px-1 py-2 items-center justify-between cursor-pointer ${selectedItem.menuId === data.id &&
                  selectedItem.submenuIndex === null
                  ? 'bg-sideDrawer-hover text-charcoal-100 rounded-md'
                  : ''
                }`}
              onClick={() => {
                toggleSubmenu(data.id);
                if (data.child?.length === 0) {
                  handleMenuClick(data.id, data.path);
                }
              }}
            >
              <div className="flex items-center gap-2">
                <img
                  src={data.image}
                  className="px-1 py-2"
                  alt={`${data.label} icon`}
                />
                <p
                  className={`text-sm ${selectedItem.menuId === data.id &&
                      selectedItem.submenuIndex === null
                      ? 'text-charcoal-100'
                      : 'text-white-100'
                    }`}
                >
                  {data.label}
                </p>
              </div>
              {data?.child?.length ? (
                <img
                  src={submenuVisibility[data.id] ? upIcon : downIcon}
                  alt="toggle icon"
                />
              ) : null}
            </div>
            {submenuVisibility[data.id] && data?.child?.length > 0 && (
              <div>
                {data.child.map((child, index) => (
                  <div
                    key={index}
                    className={`py-2 cursor-pointer pl-9 text-sm ${selectedItem.menuId === data.id &&
                        selectedItem.submenuIndex === index
                        ? 'bg-sideDrawer-hover text-charcoal-100 rounded-md'
                        : 'text-white-100'
                      }`}
                    onClick={() =>
                      handleSubmenuClick(data.id, index, child.path)
                    }
                  >
                    {child.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SideDrawer;
